import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  CreateProjectPortfolioError,
  Identifiable,
  ProjectPortfolio,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: CreateProjectPortfolioError;
  editProjectPortfolio(
    request: Boundaries["editProjectPortfolio"]["request"],
  ): void;
}

function useEditProjectPortfolio(
  portfolio: Identifiable<ProjectPortfolio>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectPortfolioRequestPending(portfolio),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectPortfolioRequestSuccess(portfolio),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectPortfolioRequestFailure(portfolio),
    ),
    error: useSelector(() => selector.getEditProjectPortfolioError(portfolio)),
    editProjectPortfolio: core.editProjectPortfolio,
  };
}

export { useEditProjectPortfolio };
